import { INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { http } from "utils/http";


export const putWarehouseIO = (data,type) =>
  http({
    baseURL: INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis[type].browse,
    method: "put",
    // headers: { "Accept-Language": "en" },
    data: data,
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });

export const getWarehouses = (
  pageNumber: number,
  pageSize: number,
  searchString,
  orderBy,
  filterlist,
  currentWarehouse,
  type
) =>
  http({
    baseURL: INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis[type].browse,
    method: "get",
    params: {
      PageNumber: pageNumber,
      PageSize: pageSize,
      SearchString: searchString,
      OrderByString: orderBy,
      FilterString: filterlist,
      warehouseId: currentWarehouse,
    },
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });

export const getWarehouseIoId = (id,type) =>
  http({
    baseURL: INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis[type].load,
    method: "get",
    headers: { "Accept-Language": "en" },
    params: {
      id,
    },
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
export const constraintWarehouseIo = (warehouseIOType,warhouseIdList,type) =>
  http({
    baseURL: INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis[type].constraint,
    method: "get",
    headers: { "Accept-Language": "en" },
    params:{
      warehouseIOType,
      warehouseIdList:encodeURI(warhouseIdList)
    }
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });

        export const getWarehouseIOByReferenceId = (ReferenceId,type ) => http({
          baseURL:INVENTORYANDSALES_URL,
          url: ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis[type].refrenceId,
    
          headers: { "Accept-Language": "en" },
          method: 'get',
          params: {
     
              ReferenceId,
           
          }
      }).then((res) => {
          return res.data
      }).catch((err) => {
          return Promise.reject(err);
      });

      export const getWarehouseIOOrGenerate = (SourceData,SourceId,ReferenceId,JobId,type,warehouseIOKindSystemKey=null ) => http({
        baseURL:INVENTORYANDSALES_URL,
        url: ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis[type].getOrGenerate,
  
        headers: { "Accept-Language": "en" },
        method: 'get',
        params: {
            SourceData,
            ReferenceId,
            JobId,
            warehouseIOKindSystemKey
        }
    }).then((res) => {
        return res.data
    }).catch((err) => {
        return Promise.reject(err);
    });
    export const postWarehouseIOWorkFlow = (data ,referenceId,type,url=null  ) => http({
      baseURL:INVENTORYANDSALES_URL,
       url:url?ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis[type][url]: ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis[type].addWorkflow,
      method: 'post',
      data:data,
      params:{referenceId},
    
    }).then((res) => {
      return res.data
    }).catch((err) => {
      return Promise.reject(err);
    });    
    export const postWarehouseIO = (data ,type,totalUrl  ) => http({
      baseURL:INVENTORYANDSALES_URL,
      url:totalUrl?totalUrl=="FromSourceWithQtyEdit"?ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis[type].FromSourceWithQtyEdit:ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis[type].FromSource: ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis[type].browse,
      method: 'post',
      data:data,
    
    }).then((res) => {
      return res.data
    }).catch((err) => {
      return Promise.reject(err);
    }); 
    
    export const putWarehouseIOworkflow = (data ,referenceId,type ) => http({
      baseURL:INVENTORYANDSALES_URL,
      url: ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis[type].putWorkflow,
      method: 'put',
      params:{referenceId},
      data:data
      
    }).then((res) => {
      return res.data
    }).catch((err) => {
      return Promise.reject(err);
    });
    export const getDataForPrint = ( Id,{type},data=null) => http({
      baseURL:INVENTORYANDSALES_URL,
      url: ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis[type].printData,
      method: "post",
      params:{
          id:Id,
          useWarmSignature: true 
      },
      data
      
  }).then((res) => {
       
      return res.data
  }).catch((err) => {
  
      return Promise.reject(err);
  });